export default __webpack_public_path__ + "static/media/make.6467b4eb.svg";